(function() {
  angular.module('cfn').controller('personGroupCoreController', [
    '$scope',
    '$rootScope',
    'CoreREST',
    'PersonGroup',
    '$http',
    '$timeout',
    '$log',
    '$dialog',
    '$injector',
    '$route',
    'FavoriteService',
    'i18nFilter',
    function(
      $scope,
      $rootScope,
      CoreREST,
      PersonGroup,
      $http,
      $timeout,
      $log,
      $dialog,
      $injector,
      $route,
      FavoriteService,
      i18nFilter
    ) {
      var mode = {
        name: 'personGroup',
        hasActive: true
      };

      var ctrl = this;
      ctrl.getEntityName = function() {
        try {
          return $scope.details.personGroup.name;
        } catch (e) {
          return '';
        }
      };

      var specialAdd = (mode.specialAdd = []);
      var ele = null;
      ele = {};
      ele.property = 'persons';
      ele.Property = 'Persons';
      specialAdd.push(ele);

      // validation engine
      var vgi = {};
      vgi['active'] = '1';
      vgi['name'] = '1';
      vgi['number'] = '1';
      vgi['persons'] = '1';
      mode.vgi = vgi;

      return coreCommonController(
        'personGroup',
        ctrl,
        mode,
        $scope,
        $rootScope,
        CoreREST,
        PersonGroup,
        $http,
        $timeout,
        $log,
        $dialog,
        $injector,
        $route,
        FavoriteService,
        i18nFilter
      );
    }
  ]);
})();
